document.addEventListener('DOMContentLoaded', () => {
  const planQuizElement = document.querySelector('.plan-quiz');
  if (!planQuizElement) {
    return;
  }

  const planBack = planQuizElement.querySelector('[data-plan-back]');
  const quizSteps = Array.from(planQuizElement.querySelectorAll('.plan-quiz__step'));

  const replaceBrowserUrl = url => {
    const nextUrl = `${url.pathname}${url.search}${url.hash}`;
    window.history.replaceState({}, '', nextUrl);
  };

  const getActiveStepIndex = () => {
    return quizSteps.findIndex(step => step.classList.contains('plan-quiz__step--active'));
  };

  const showQuiz = () => {
    planQuizElement?.classList.add('plan-quiz--visible');
  };

  const hideQuiz = () => {
    planQuizElement?.classList.remove('plan-quiz--visible');
  };

  const setActiveStep = nextIndex => {
    const currentIndex = getActiveStepIndex();

    if (currentIndex === -1 || !quizSteps[nextIndex]) {
      return;
    }

    quizSteps[currentIndex].classList.remove('plan-quiz__step--active');
    quizSteps[nextIndex].classList.add('plan-quiz__step--active');
  };

  if (window.location.hash === '#plan-quiz') {
    showQuiz();
  }

  document.addEventListener('click', e => {
    const triggerLink = e.target.closest('a[href]');

    if (!triggerLink) {
      return;
    }

    const linkHash = new URL(triggerLink.href, window.location.origin).hash;

    if (linkHash === '#plan-quiz') {
      showQuiz();
    }
  });

  const showPrevStep = () => {
    const activeStepIndex = getActiveStepIndex();

    if (activeStepIndex > 0) {
      setActiveStep(activeStepIndex - 1);
    } else {
      clearStepSearchParams({ clearHash: true });
      hideQuiz();
    }
  };

  const clearStepSearchParams = ({ clearHash = false } = {}) => {
    const url = new URL(window.location.href);

    quizSteps.forEach((quizStep, i) => {
      const step = quizStep.dataset.step || `step-${i}`;
      url.searchParams.delete(step);
    });

    if (clearHash && url.hash === '#plan-quiz') {
      url.hash = '';
    }

    replaceBrowserUrl(url);
  };

  if (planBack) {
    planBack.addEventListener('click', () => {
      showPrevStep();
    });
  }

  quizSteps.forEach((quizStep, i) => {
    // How many selections are required
    const selectionsRequiredRaw = Number(quizStep.dataset.selectionsRequired);
    // Better handling of selection requirements
    const selectionsRequired =
      Number.isFinite(selectionsRequiredRaw) && selectionsRequiredRaw > 0
        ? selectionsRequiredRaw
        : 1;
    // Inputs
    const inputs = Array.from(quizStep.querySelectorAll('input'));
    // Checkboxes - used if we have more than 1 selection required
    const checkboxInputs = inputs.filter(input => input.type === 'checkbox');
    // The step value
    const step = quizStep.dataset.step || `step-${i}`;
    // The progress button
    const progressBtn = quizStep.querySelector('[data-progress-btn]');
    // The step attribute key, set on the progress button
    const stepAttributeKey = progressBtn?.dataset.key ? `_${progressBtn.dataset.key}` : '';
    // Cart URL for tracking selections as cart attributes
    const cartUpdateUrl = `${theme?.routes?.cart_update_url || '/cart/update'}.js`;

    if (!progressBtn || !inputs.length) {
      return;
    }

    const getCheckedInputs = () => inputs.filter(input => input.checked);
    const getSelectedValues = () => getCheckedInputs().map(input => input.value);

    const updateStepSearchParam = () => {
      if (!step) {
        return;
      }

      const selectedValues = getSelectedValues();
      const url = new URL(window.location.href);

      if (selectedValues.length) {
        url.searchParams.set(step, selectedValues.join(','));
      } else {
        url.searchParams.delete(step);
      }

      replaceBrowserUrl(url);
    };

    // Save this step's selection(s) to cart attributes using the step key.
    const updateCartAttribute = async () => {
      if (!stepAttributeKey) {
        return;
      }

      const selectedValues = getSelectedValues();

      try {
        await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              [stepAttributeKey]: selectedValues.join(', ')
            }
          })
        });
      } catch (error) {
        console.error('Plan quiz cart attribute update failed', error);
      }
    };

    const showNextStep = () => {
      const activeStepIndex = getActiveStepIndex();

      if (activeStepIndex > -1 && activeStepIndex < quizSteps.length - 1) {
        setActiveStep(activeStepIndex + 1);
      } else {
        setTimeout(() => {
          window.location.href = `${theme?.routes?.root_url}products/the-press-plan`;
        }, 500);
      }
    };

    // Keeps button state and checkbox locking in sync with current selections.
    const updateStepState = () => {
      const inputsChecked = getCheckedInputs().length;

      progressBtn.disabled = !(inputsChecked >= 1 && inputsChecked <= selectionsRequired);

      if (!checkboxInputs.length) {
        return;
      }

      const limitReached = inputsChecked >= selectionsRequired;

      checkboxInputs.forEach(checkboxInput => {
        const parentLabel = checkboxInput.closest('label');
        const shouldDisable = limitReached && !checkboxInput.checked;

        checkboxInput.disabled = shouldDisable;

        if (parentLabel) {
          parentLabel.classList.toggle('plan-quiz__selection--disabled', shouldDisable);
        }
      });
    };

    updateStepState();

    quizStep.addEventListener('change', event => {
      if (event.target instanceof HTMLInputElement && inputs.includes(event.target)) {
        updateStepState();
        updateStepSearchParam();
      }
    });

    progressBtn.addEventListener('click', () => {
      updateCartAttribute();
      showNextStep();
    });
  });
});
